import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { Specialties } from "@/components/landing/Specialties";
import { Garage } from "@/components/landing/Garage";
import { VisitShop } from "@/components/landing/VisitShop";
import { InquiryForm } from "@/components/landing/InquiryForm";
import { Footer } from "@/components/landing/Footer";

export default function LandingPage() {
  return (
    <main data-testid="landing-page" className="bg-[#0A0A0A] text-white">
      <Navbar />
      <Hero />
      <Specialties />
      <Garage />
      <VisitShop />
      <InquiryForm />
      <Footer />
    </main>
  );
}
